import React from 'react'
import { Col, Row, Button } from "react-bootstrap";

const Statistics = () => {
  return (
    <div>
      <Row>
        <Col className='d-flex justify-content-center'>
        <h2 lg='7'>Bidder's Info</h2>

        </Col>
        <Col className='d-flex justify-content-center'>
        <img src="" alt="Graph for biders" />
        </Col>
      </Row>
    </div>
  )
}

export default Statistics
